// extracted by mini-css-extract-plugin
export default {"projectActivitiesWidgetWrapper":"ProjectActivitiesPage_projectActivitiesWidgetWrapper__Ms84m"};